import { ChartType } from "../../../models/chart_model";

export const R_CHART_TYPES = [
  { value: ChartType.Bar, label: "Standard Bar", stackId: undefined },
  { value: ChartType.Bar, label: "Stacked Bar", stackId: "a" },
  { value: ChartType.Line, label: "Line" },
];

export const R_AREA_CHART_TYPES = {
  value: ChartType.Area,
  label: "Area",
  stackId: "stacked",
};

export const T_CHART_TYPES = [{ value: ChartType.Line, label: "Line" }];

// export function getLast7DaysDateRange() {
//   // Create dates using local timezone
//   const today = new Date();
//   today.setHours(0, 0, 0, 0); // Set to beginning of day in local timezone

//   const sevenDaysAgo = new Date(today);
//   sevenDaysAgo.setDate(today.getDate() - 7);

//   // Return the objects directly
//   return {
//     startDate: sevenDaysAgo,
//     endDate: today,
//     key: "selection",
//   };
// }

export function getLast7DaysDateRange() {
  // Get current date
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Find last Sunday (end of previous week)
  const lastSunday = new Date(today);

  // Find last Monday (start of previous week)
  const lastMonday = new Date(lastSunday);
  lastMonday.setDate(lastSunday.getDate() - 6);

  // Return the previous week date range
  return {
    startDate: lastMonday,
    endDate: lastSunday,
    key: "selection",
  };
}

// NEW FUNCTION: Use this to format dates for API calls
export function formatDateForAPI(date: Date): string {
  // Format date in YYYY-MM-DD format preserving local date
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
